/**
 * @file
 * Behaviors for the hero.
 */
/* eslint-disable max-len */

(function (Drupal) {
  /**
   * Setup and attach the Hero behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.hero = {
    attach: function () {
      const heroItem = document.querySelector('.hero--video');

      if (heroItem) {
        // Get the video element from the same heroItem container.
        const video = heroItem.querySelector('.hero--video video');
        const videoPause = heroItem.querySelector(
          '.hero--video .btn-play-pause span#pause'
        );
        const videoPlay = heroItem.querySelector(
          '.hero--video .btn-play-pause span#play'
        );

        let clickHandler = function () {
          if (video.paused) {
            video.play();
            videoPause.style.display = 'block';
            videoPlay.style.display = 'none';
          }
          else {
            video.pause();
            videoPause.style.display = 'none';
            videoPlay.style.display = 'block';
          }
        };

        // Guard this with once
        const btn = heroItem.querySelector('.hero--video .btn-play-pause');
        once('hero-video-click', btn).forEach(element => {
          element.addEventListener('click', clickHandler);

          if (video.paused) {
            videoPause.style.display = 'none';
            videoPlay.style.display = 'block';
          }
          else {
            videoPause.style.display = 'block';
            videoPlay.style.display = 'none';
          }
        });
      }
    }
  };
})(Drupal);

// const Player = document.getElementById('hero-video');
//       const PlayBtn = document.getElementById('play-btn');
//       const VideoCover = document.getElementById('placeholder');

//       let times = 0, playY;
//       const playVideo = PlayBtn.addEventListener( 'click' , () => {
//           if(times == 0){
//             playY = Player.src += '?autoplay=1';
//             times = 1;
//             Player.style.display='block';
//             Player.classList.add("hero--play")
//             PlayBtn.style.display='none';
//             VideoCover.style.display='none';
//           }
//       });
